var React = require('react');

function HeartInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m290.000014 68.7142878c-.214286 0-.428572-.0803573-.589286-.2410718l-8.357153-8.0625096c-.107143-.0937501-3.053575-2.7857176-3.053575-6.0000071 0-3.9241118 2.397324-6.2678646 6.401793-6.2678646 2.343753 0 4.540184 1.8482165 5.598221 2.8928606 1.058037-1.0446441 3.254468-2.8928606 5.598221-2.8928606 4.004469 0 6.401794 2.3437528 6.401794 6.2678646 0 3.2142895-2.946432 5.906257-3.066968 6.0267929l-8.34376 8.0357238c-.160715.1607145-.375001.2410718-.589287.2410718z","fill":"#fff","opacity":".5","transform":"translate(-278 -48)"}));
}

HeartInline.defaultProps = {"height":"21","viewBox":"0 0 24 21","width":"24"};

module.exports = HeartInline;

HeartInline.default = HeartInline;
